<script setup>
import {ref, watch} from 'vue'
import {codePreview, formatDate} from '@/helper';
import {Dialog, DialogPanel, DialogTitle, TransitionChild, TransitionRoot} from '@headlessui/vue'
import Textarea from '@/components/forms/Textarea.vue';
import Select from '@/components/forms/Select.vue';

import {useI18n} from 'vue-i18n'

const {t} = useI18n();

const props = defineProps({
  client: {type: Object, required: false},
  type: {type: String, required: false},
});

const form = ref({type: props.type || 'message', attachments: []});

function handleFileChange(e) {
    form.value.attachments = Array.from(e.target.files);
}
const types = [
  {label: t('createServiceRequirementModal.deposit'), value: 'deposit'},
  // {label: 'Výběr', value: 'withdraw'},
  {label: t('createServiceRequirementModal.client_identification'), value: 'client_identification'},
  {label: t('createServiceRequirementModal.message'), value: 'message'}
];
const isOpen = ref(true)
const emit = defineEmits(['confirm', 'cancel']);
const closeModalWith = (value) => {
  isOpen.value = false;
  setTimeout(() => {
    if (value === 'confirm') {
      emit('confirm', form.value);
    } else {
      emit('cancel');
    }
  }, 300);
}

function openModal() {
  isOpen.value = true
}
</script>

<template>
  <TransitionRoot appear :show="isOpen" as="template">
    <Dialog as="div"  class="modal show d-block" style="z-index: 1055;">
      <div class="modal-backdrop fade show"></div>
      <div class="modal-dialog modal-dialog-centered modal-lg" style="z-index: 1055">
        <div class="modal-content">
          <DialogPanel class="modal-body p-4 rounded-lg shadow-lg">
            <div class="modal-header">
              <DialogTitle as="h3" class="modal-title">
                {{ t('createServiceRequirementModal.create_service_request') }}</DialogTitle>
              <i class="btn-close cursor-pointer" @click="closeModalWith('cancel')" aria-label="Close"></i>
            </div>
            <form @submit.prevent="closeModalWith('confirm')">
              <div class="modal-body">
                <!-- Typ požadavku je dočasně skryt — interně se defaultuje na "message" -->
              <div v-show="false">
                <select v-model="form.type" class="form-select" id="type">
                  <option :key="index" v-for="(type, index) in types" :value="type.value">{{type.label}}</option>
                </select>
              </div>
                <div class="row mb-3">
                  <div class="col-12 form-group">
                    <label for="text" class="form-label">{{ t('createServiceRequirementModal.text') }}</label>
                    <textarea v-model="form.request_text" class="form-control" id="text" rows="3" :placeholder="t('createServiceRequirementModal.text_message')"></textarea>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 form-group">
                    <label class="form-label">{{ t('createServiceRequirementModal.attachments') }}</label>
                    <input type="file" multiple class="form-control" @change="handleFileChange"/>
                  </div>
                </div>

              </div>

              <div class="modal-footer">
                <button class="btn btn-link text-decoration-underline text-dark" @click="closeModalWith('cancel')">{{ t('createServiceRequirementModal.cancel') }}</button>
                <button class="btn btn-primary btn-md" type="submit">{{ t('createServiceRequirementModal.save') }}</button>
              </div>
            </form>
          </DialogPanel>
        </div>
      </div>
    </Dialog>
  </TransitionRoot>
</template>

